
import Forgot from '../pages/auth/Forgot.jsx';
import Login from '../pages/auth/Login.jsx';
import Otp from '../pages/auth/Otp.jsx';
import Register from '../pages/auth/Register.jsx';
import ResetPassword from '../pages/auth/ResetPassword.jsx';
import SignUp from '../pages/auth/SignUp.jsx';
import Blogs from '../pages/blogs/Blogs.jsx';
import BookDemoRequest from '../pages/BookDemoRequest/BookDemoRequest.jsx';
import Chat from '../pages/chat/Chat.jsx';
import Dashboard from '../pages/dashboard/Dashboard.jsx';
import Trash from '../pages/document/components/Trash.jsx';
import Document from '../pages/document/Document.jsx';
import CreateFiles from '../pages/files/components/CreateFiles.jsx';
import QuestionAnswerFlow from '../pages/files/components/QuestionAnswerFlow.jsx';
import Files from '../pages/files/Files.jsx';
import AdminWiseClientList from '../pages/License/AdminWiseClientList.jsx';
import License from '../pages/License/License.jsx';
import PaymentType from '../pages/PaymentType/PaymentType.jsx';
import Plans from '../pages/plans/Plans.jsx';
import PaymentSuccessLicense from '../pages/public/PaymentSuccessLicense.jsx';
import Settings from '../pages/settings/Settings.jsx';
import UpgradePlans from '../pages/upgradePlan/UpgradePlans.jsx';
import UpgradePlanDiscount from '../pages/upgradePlanDiscount/UpgradePlanDiscount.jsx';

export const initialRoutes = () => {
    const routes = [
        // ============ Auth ===============
        { path: "/login", type: "auth", component: Login, title: 'Login' },
        { path: "/signup", type: "auth", component: SignUp, title: 'SignUp' },
        { path: "/register", type: "auth", component: Register, title: 'Register' },
        { path: "/otp", type: "auth", component: Otp, title: 'Otp' },
        { path: "/forget_password", type: "auth", component: Forgot, title: 'ForgotPassword' },
        { path: "/change_password/:token", type: "auth", component: ResetPassword, title: 'ResetPassword' },
        // ============ Public =============
        { path: "/payment-success-license", type: "public", component: PaymentSuccessLicense, title: 'PaymentSuccessLicense' },

        // ============ Privet ==============
        { path: "/", type: "private", component: Dashboard, title: "Dashboard" },
        { path: "/dashboard", type: "private", component: Dashboard, title: "Dashboard" },
        { path: "/license", type: "private", component: License, title: "License" },
        { path: "/client_list/:id", type: "private", component: AdminWiseClientList, title: "Clients"},
        { path: "/document", type: "private", component: Document, title: "Document" },
        { path: "/plans", type: "private", component: Plans, title: "Plans" },
        { path: "/upgrade_plan", type: "private", component: UpgradePlans, title: "Upgrade Plan" },
        { path: "/payment_type", type: "private", component: PaymentType, title: "Payment Type" },
        { path: "/book_demo_request", type: "private", component: BookDemoRequest, title: "Book Demo Request" },
        { path: "/plan_discount", type: "private", component: UpgradePlanDiscount, title: "Plan Discount" },
        { path: "/blogs", type: "private", component: Blogs, title: "Blogs" },
        { path: "/documents_trash", type: "private", component: Trash, title: "Trash" },
        { path: "/files", type: "private", component: Files, title: "Files" },
        { path: "/create_files", type: "private", component: CreateFiles, title: "Files" },
        { path: "/question_answer_flow", type: "private", component: QuestionAnswerFlow, title: "Question Answer Flow" },
        { path: "/chat", type: "private", component: Chat, title: "Chat" },
        { path: "/settings", type: "private", component: Settings, title: "settings" },
        
    ]
    return routes;
}